import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import HarvesterViewNew from 'src/views/harvesting';
import {HarvesterLandScreen} from 'src/views/harvest-land';
import PrivacyPolicy from 'src/views/privacyPolicy';
import RegisterView from 'src/views/register';
import ReportBugs from 'src/views/reportBugs';
import ShareFruit from 'src/views/readShareFruitToOthers';
import ForceReset from 'src/views/ForceReset';
import {ResultScreen} from 'src/views/results/results';
import {UserManagementScreen} from 'src/views/user-management';
import {AttendanceManagementScreen,AttendanceSingleScreen} from 'src/views/attendance';
import {FishingResultScreen} from 'src/views/fishing-result';


const routes = [
  { path: 'force-reset', element: <ForceReset /> },
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      // { path: 'dashboard', element: <DashboardView /> },
      { path: 'harvesting', element: <HarvesterViewNew /> },
      { path: 'harvestland', element: <HarvesterLandScreen /> },
      { path: 'result', element: <ResultScreen /> },
      { path: 'users', element: <UserManagementScreen /> },
      { path: 'attendance', children:[
        {path:'',element: <AttendanceManagementScreen /> },
        {path:':id',element: <AttendanceSingleScreen /> }
      ]},
      { path: 'ev-results', element: <FishingResultScreen/>},
      { path: 'report-bugs', element: <ReportBugs /> },
      { path: 'share-is-love',element:<ShareFruit/>},
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'welcome', element: <RegisterView /> },
      { path: 'login', element: <LoginView /> },
      { path: '404', element: <NotFoundView /> },
      { path: 'privacy-policy', element:<PrivacyPolicy/>},
      { path: '/', element: <Navigate to="/app/harvesting" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
